import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.less';

const TrainingType = ({ image, text, active, description }) => (
  <div className={`${styles.card} ${active && styles.active}`}>
    <div className={styles.image}>
      <img src={image} alt="TypeImage" />
    </div>
    <div className={styles.flex}>
      <h3>{text}</h3>
      <p>{description}</p>
    </div>
  </div>
);

TrainingType.propTypes = {
  image: PropTypes.string,
  text: PropTypes.string,
  active: PropTypes.bool,
  description: PropTypes.string.isRequired,
};

TrainingType.defaultProps = {
  image: '',
  text: '',
  active: false,
};

export default TrainingType;
